export function CustomerDetailLoading() {
  return (
    <div className="container mx-auto py-6 max-w-4xl">
      <div className="flex justify-center items-center h-60">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <h2 className="text-xl font-medium text-gray-700">Loading customer details...</h2>
        </div>
      </div>
    </div>
  );
}
